import { Translations } from './translations'

export const en: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'AI Training Tycoon',
  settings: 'Settings',

  // Resources
  resources: 'Resources',
  money: 'Money',
  energy: 'Energy',
  compute: 'Compute',
  quality: 'Quality',
  totalUsers: 'Total Users',
  price: 'Price',
  research: 'Research',

  // Actions
  train: 'Train',
  trainCost: 'Cost',
  qualityGain: 'quality',
  inference: 'Inference',
  needUsers: 'Need users!',
  usersWaiting: 'users waiting',
  qualityToAttract: 'Quality > 40% to attract',
  researchAction: 'Research',
  unlocksAfter: 'Unlocks after',
  computeSpent: 'compute spent',
  cost: 'Cost',
  compShort: 'comp',
  energyShort: 'energy',

  // Hardware
  hardware: 'Hardware',
  computePerSec: 'compute/s',
  usesEnergy: 'uses',
  devicesTotal: 'devices total',

  // Models
  training: 'Training',
  yourModels: 'Your Models',
  params: 'params',
  maxUsers: 'Max users',
  trainCost2: 'Train cost',
  unlocked: 'unlocked',
  researchPoints: 'research',

  // Upgrades
  upgrades: 'Upgrades',
  upgradesLockedMsg: 'Train your model to 50% quality to unlock upgrades',
  max: 'MAX',
  all: 'All',
  
  // Upgrade tiers
  tierGarage: 'Garage',
  tierGarageDesc: 'The beginning',
  tierStartup: 'Startup',
  tierStartupDesc: 'GPT-1 Era',
  tierScaleUp: 'Scale-up',
  tierScaleUpDesc: 'GPT-2/3 Era',
  tierEnterprise: 'Enterprise',
  tierEnterpriseDesc: 'ChatGPT Era',
  tierHyperscale: 'Hyperscale',
  tierHyperscaleDesc: 'GPT-4 Era',
  tierGlobal: 'Global',
  tierGlobalDesc: 'Competitor Era',
  tierSuperintelligence: 'Superintelligence',
  tierSuperintelligenceDesc: 'GPT-5+ Era',
  tierSingularity: 'Singularity',
  tierSingularityDesc: 'AGI/ASI Era',

  // Footer
  computeSpentStat: 'Compute Spent',
  time: 'Time',
  resetGame: 'Reset Game',
  resetConfirm: 'Are you sure you want to reset all progress?',
  pause: 'Pause',
  resume: 'Resume',

  // Event Log
  eventLog: 'Event Log',
  welcome: 'Welcome to GPT Clicker! Train your model to begin.',

  // Price
  market: 'Market',
  pricePerMillion: '$/1M tokens',

  // Tags
  tagEnergy: 'ENRGY',
  tagCompute: 'COMP',
  tagHw: 'HW',
  tagTrain: 'TRAIN',
  tagResearch: 'RSRCH',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Year 2020. You have an idea: train a small language model based on the transformer architecture.',
  tutorialFirstTrain: 'Training started! Your laptop converts energy into compute. Each training run improves model quality.',
  tutorialQuality20: 'Model is learning basic patterns. Keep training to improve quality.',
  tutorialQuality40: 'Quality above 40%! Your model can now generate somewhat coherent text. Users are starting to notice...',
  tutorialQuality50: 'Upgrades unlocked! Use your earnings to buy better hardware and expand your energy capacity.',
  tutorialFirstUsers: 'Your first users! Click INFERENCE to serve their requests and earn money.',
  tutorialUsers10: 'Word is spreading. More users are trying your model. Consider raising the price...',
  tutorialMoney100: 'You have $100! Time to upgrade your hardware. Better GPUs = more compute = faster training.',
  tutorialMoney1k: 'Your little AI project is becoming a real business. Investors are starting to call...',
  tutorialResearchUnlock: 'RESEARCH unlocked! Spend compute on research to unlock bigger, more powerful models.',
  tutorialFirstResearch: 'Research points accumulate. When you have enough, you can unlock the next model architecture.',
  tutorialGpt2Small: 'GPT-2 Small unlocked! This architecture can handle more complex tasks. Train it from scratch.',
  tutorialGpt2Large: 'GPT-2 Large! People are saying this might be "too dangerous to release"...',
  tutorialGpt3: 'GPT-3 era begins. Few-shot learning changes everything. The world is watching.',
  tutorialGpt4: 'GPT-4 is here. Multimodal, reasoning, and scarily capable. The AI race intensifies.',
  tutorialAgi: 'You did it. AGI is here. It understands. It improves itself. What happens next is up to you...',
  tutorialHwGaming: 'Nice GPU! Training is much faster now. Your neighbors might complain about the electricity bill.',
  tutorialHwServer: "A real server rack! You've moved beyond the garage. Time to rent some office space.",
  tutorialHwDatacenter: "Your own datacenter! You're now competing with the big tech companies.",
  tutorialHwSatellite: 'Orbital compute! The Moonlink constellation provides unprecedented processing power from space.',
  tutorialHwQuantum: 'Quantum supremacy achieved. The QC-1024 operates on principles that would make Einstein nervous.',
  tutorialUsers100: "100 users! You're gaining traction. Tech blogs are writing about you.",
  tutorialUsers1k: '1,000 users! You need to hire a support team. And maybe some lawyers.',
  tutorialUsers100k: "100K users! You're a unicorn startup now. VCs are fighting to give you money.",
  tutorialUsers1m: "ONE MILLION USERS! You're reshaping how humanity interacts with technology.",

  // Model descriptions
    modelTinyDesc: 'A humble beginning. Barely coherent, but it works.',
    modelGpt2SmallDesc: 'The model that started it all. Actually useful.',
    modelGpt2LargeDesc: 'Too dangerous to release... or is it?',
    modelGpt3Desc: 'Few-shot learning. The world takes notice.',
    modelGpt4Desc: 'Multimodal. Reasoning. The arms race begins.',
    modelAgiDesc: 'It understands. It improves itself. What now?',
    
    // Model descriptions (new keys for all models)
    modelTransformerDesc: 'A humble beginning. The transformer architecture is born.',
    modelGpt1Desc: 'Generative Pre-Training. Language models can learn!',
    modelGpt2Desc: 'Too dangerous to release... or is it?',
    modelGpt35Desc: 'RLHF magic. ChatGPT goes viral overnight.',
    modelGpt41Desc: 'Faster, cheaper, better. The iteration game.',
    modelU1Desc: 'A wild competitor appears. Reasoning breakthroughs.',
    model2UDesc: 'The sequel. Chain-of-thought on steroids.',
    modelGpt5Desc: 'PhD-level reasoning. Scientists are nervous.',
    modelGpt6Desc: 'It writes better code than most engineers. All previous models discontinued.',
    modelGpt7Desc: 'Artificial general competence achieved.',
    modelAgi1Desc: 'It understands. It learns. It improves itself.',
    modelAgi2Desc: 'Recursive self-improvement. The singularity approaches.',
    modelAgi3Desc: 'The final AGI iteration. Preparing for transcendence.',
     modelAsiDesc: 'Artificial Superintelligence. The Singularity is here.',

   // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Overclock Laptop',
  upgradeLaptopOverclockDesc: 'Push your laptop harder: +2 compute/sec',
  upgradeBetterOutlet: 'Better Power Outlet',
  upgradeBetterOutletDesc: '+50 max energy',
  upgradeSolarPanel: 'Solar Panel',
  upgradeSolarPanelDesc: '+1 energy/sec regen',
  upgradePowerGrid: 'Power Grid Connection',
  upgradePowerGridDesc: '+5 energy/sec regen',
  upgradeNuclearPlant: 'Nuclear Plant',
  upgradeNuclearPlantDesc: '+20 energy/sec regen',
  upgradeFusionReactor: 'Fusion Reactor',
  upgradeFusionReactorDesc: '+100 energy/sec regen',
  upgradeDysonSphere: 'Dyson Sphere',
  upgradeDysonSphereDesc: '+1000 energy/sec regen',
  upgradeRamUpgrade: 'RAM Upgrade',
  upgradeRamUpgradeDesc: '+50 max compute',
  upgradeSsdArray: 'SSD Array',
  upgradeSsdArrayDesc: '+200 max compute',
  upgradeBetterOptimizer: 'Better Optimizer',
  upgradeBetterOptimizerDesc: '+20% training efficiency',
  upgradeResearchPapers: 'Research Papers',
  upgradeResearchPapersDesc: '+20% research efficiency',
  upgradeSelfServicePortal: 'Self-Service Portal',
  upgradeSelfServicePortalDesc: 'Users serve themselves: 0.5 auto-inferences/sec',
  upgradeApiAccess: 'API Access',
  upgradeApiAccessDesc: 'Developers integrate your model: +1 auto-inference/sec',
  upgradeMobileApp: 'Mobile App',
  upgradeMobileAppDesc: 'Users on the go: +2 auto-inferences/sec',
  upgradeEnterpriseTier: 'Enterprise Tier',
  upgradeEnterpriseTierDesc: 'Big clients, big volume: +5 auto-inferences/sec',
  upgradeGlobalCdn: 'Global CDN',
  upgradeGlobalCdnDesc: 'Worldwide low-latency: +10 auto-inferences/sec',
  upgradeBasicChatbot: 'Basic Chatbot',
  upgradeBasicChatbotDesc: 'A simple web widget: +0.2 auto-inferences/sec',
  upgradeBulkApi: 'Bulk API',
  upgradeBulkApiDesc: 'High-volume batch processing: +3 auto-inferences/sec',
  upgradeNeuralEdge: 'Neural Edge Network',
  upgradeNeuralEdgeDesc: 'AI at the edge: +20 auto-inferences/sec',
  upgradeQuantumInference: 'Quantum Inference',
  upgradeQuantumInferenceDesc: 'Quantum-accelerated inference: +50 auto-inferences/sec',
  upgradeOmnipresentAi: 'Omnipresent AI',
  upgradeOmnipresentAiDesc: 'AI everywhere, all at once: +100 auto-inferences/sec',
  upgradeTrainingScheduler: 'Training Scheduler',
  upgradeTrainingSchedulerDesc: 'Automated training runs: +0.1 auto-trains/sec',
  upgradeTrainingPipeline: 'Training Pipeline',
  upgradeTrainingPipelineDesc: 'Continuous training: +0.2 auto-trains/sec',
  upgradeMlOpsPlatform: 'MLOps Platform',
  upgradeMlOpsPlatformDesc: 'Full automation: +0.5 auto-trains/sec',
  upgradeNeuralArchitectureSearch: 'Neural Architecture Search',
  upgradeNeuralArchitectureSearchDesc: 'AI trains AI: +1 auto-train/sec',
  upgradeSelfImprovingTraining: 'Self-Improving Training',
  upgradeSelfImprovingTrainingDesc: 'Recursive improvement: +2 auto-trains/sec',
  upgradeResearchIntern: 'Research Intern',
  upgradeResearchInternDesc: 'Entry-level help: +0.1 auto-research/sec',
  upgradeResearchTeam: 'Research Team',
  upgradeResearchTeamDesc: 'Dedicated researchers: +0.2 auto-research/sec',
  upgradeResearchDivision: 'Research Division',
  upgradeResearchDivisionDesc: 'Full department: +0.5 auto-research/sec',
  upgradeAiResearchLab: 'AI Research Lab',
  upgradeAiResearchLabDesc: 'AI-assisted discovery: +1 auto-research/sec',
  upgradeAutonomousResearch: 'Autonomous Research',
  upgradeAutonomousResearchDesc: 'AI does the research: +2 auto-research/sec',
  upgradeAntimatterReactor: 'Antimatter Reactor',
  upgradeAntimatterReactorDesc: '+10000 energy/sec regen',
  upgradePhDScientists: 'PhD Scientists',
  upgradePhDScientistsDesc: 'Hire top talent: +200% research efficiency',
  upgradeResearchLab: 'Research Lab',
  upgradeResearchLabDesc: 'Dedicated facility: +500% research efficiency',
  upgradeAiResearchAssistant: 'AI Research Assistant',
  upgradeAiResearchAssistantDesc: 'GPT-4 helps with research: +1000% research efficiency',
  upgradeAiScientist: 'AI Scientist',
  upgradeAiScientistDesc: 'AI conducts experiments autonomously: +2000% research efficiency',
  upgradeResearchSwarm: 'AI Research Swarm',
  upgradeResearchSwarmDesc: 'Thousands of AI researchers: +5000% research efficiency',
  upgradeRecursiveResearch: 'Recursive Self-Improvement',
  upgradeRecursiveResearchDesc: 'AI improves AI: +10000% research efficiency',
  upgradeSingularityResearch: 'Singularity Research',
  upgradeSingularityResearchDesc: 'Beyond comprehension: +50000% research efficiency',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: 'Used GPU: +3 compute/sec',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'Gaming GPU: +8 compute/sec',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'Pro GPU: +20 compute/sec',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'Workstation: +50 compute/sec',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'Server rack (4x A100): +120 compute/sec',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'GPU cluster (8x H100): +300 compute/sec',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'Edge datacenter: +800 compute/sec',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'Datacenter: +2K compute/sec',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'Mega datacenter: +5K compute/sec',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'Global network: +15K compute/sec',
  upgradeHwSupercomputer: 'Frontier X1 Supercomputer',
  upgradeHwSupercomputerDesc: 'Supercomputer: +50K compute/sec',
  upgradeHwSatellite: 'SkyNet Moonlink Constellation',
  upgradeHwSatelliteDesc: 'Orbital satellites: +200K compute/sec',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: 'Quantum computer: +1M compute/sec',
  upgradeHwDysonCompute: 'Dyson Compute Sphere',
  upgradeHwDysonComputeDesc: 'Stellar-scale computing: +10M compute/sec',
  upgradeHwMatrioshka: 'Matrioshka Brain',
  upgradeHwMatrioshkaDesc: 'Galaxy-brain computing: +100M compute/sec',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: 'Used GPU: +3 compute/sec',
  hwGamingGpuDesc: 'Gaming GPU: +8 compute/sec',
  hwProGpuDesc: 'Pro GPU: +20 compute/sec',
  hwWorkstationDesc: 'Workstation: +50 compute/sec',
  hwServerRackDesc: 'Server rack (4x A100): +120 compute/sec',
  hwGpuClusterDesc: 'GPU cluster (8x H100): +300 compute/sec',
  hwMiniDatacenterDesc: 'Edge datacenter: +800 compute/sec',
  hwDatacenterDesc: 'Datacenter: +2K compute/sec',
  hwMegaDatacenterDesc: 'Mega datacenter: +5K compute/sec',
  hwDatacenterNetworkDesc: 'Global network: +15K compute/sec',
   hwSupercomputerDesc: 'Supercomputer: +50K compute/sec',
   hwSatelliteDesc: 'Orbital satellites: +200K compute/sec',
   hwQuantumDesc: 'Quantum computer: +1M compute/sec',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: 'Purchased',
  switchedTo: 'Switched to training',
  unlockedModel: 'Unlocked',
  scalesToUsers: 'Scales to',
  trainItToAttract: 'users. Train it to attract users!',
  unlimited: 'unlimited',
  language: 'Language',
  
  // Mobile labels
  mobileResources: 'Resources',
  mobileModels: 'Models',
  mobileHardware: 'Hardware',
  mobileUpgrades: 'Upgrades',
  sell: 'Sell',
  sellFor: 'Sell for',
  discontinueConfirm: 'Discontinue {model}? Users will migrate to other models.',
  autoInference: 'Auto-inference',
  autoInferenceRate: 'Auto Infer',
  autoTrain: 'Auto-train',
  autoTrainRate: 'Auto Train',
  autoResearch: 'Auto-research',
  autoResearchRate: 'Auto Research',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Train AI models, serve users, build your AI empire!',
  tooltipMoney: 'Money - Earned from user inferences. Use to buy upgrades and hardware.',
  tooltipEnergy: 'Energy - Regenerates over time. Powers your hardware to generate compute.',
  tooltipCompute: 'Compute - Generated by hardware. Used for training, inference, and research.',
  tooltipResearch: 'Research Points - Spend compute to earn RP. Use RP to unlock new AI models.',
  tooltipUsers: 'Users - Attracted by model quality. More users = more revenue per inference.',
  tooltipComputeSpent: 'Total Compute Spent - Lifetime compute used for training and research.',
  tooltipPlayTime: 'Play Time - How long you\'ve been building your AI empire.',
  tooltipSettings: 'Settings - Debug options, reset game',

  // Share
  shareButton: 'Share',
  shareText: "I'm building an AI empire in GPT Clicker! {users} users, {money} revenue, training {model}. Can you beat my {time} run?",
  shareCopied: 'Text copied!',
  imageCopied: 'Image copied!',
  shareChallenge: 'Can you beat me?',
  shareTitle: 'Share your progress',
  shareDownload: 'Save Image',
  model: 'Model',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Send Feedback',
  feedbackPlaceholder: 'Tell us what you think about GPT Clicker...',
  feedbackEmailPlaceholder: 'Email (optional)',
  feedbackSend: 'Send',
  feedbackSending: 'Sending...',
  feedbackSuccess: 'Thanks for your feedback!',
  feedbackError: 'Error sending feedback. Please try again.',
  feedbackRateLimit: 'Too many requests. Please wait before sending more feedback.',
  feedbackClose: 'Close',

  // Console messages
  consoleGameLoaded: 'Game loaded from save',
  consoleGameSaved: 'Game saved',
  consoleFailedToSave: 'Failed to save game:',
  consoleFailedToLoad: 'Failed to load game:',
  consoleFailedToClear: 'Failed to clear save:',

  // Victory
  victoryTitle: 'Congratulations!',
  victorySubtitle: 'Human Civilization has reached the Singularity',
  victoryTime: 'Time to Singularity',
  victoryCta: 'Should we build Singularity Clicker? Leave a comment on social media!',
  victoryClose: 'Continue Playing',
}
